// Settings — LAYOUT route. Renders <Outlet /> so child routes
// (settings.users, settings.channels, settings.api-keys, settings.branding,
// and the settings.index cards page) can mount.
//
// The cards-grid landing UI moved to settings.index.tsx; that's the route
// that matches `/settings` exactly. This file matches any `/settings/*`
// path and provides the parent slot.

import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/settings')({
  component: function SettingsLayoutRoute() {
    return <Outlet />;
  },
});
